/**
 * @description parse elem html
 * @author wangfupeng
 */

import type { SlateElement } from "@wangeditor/editor";
import type { VariableElement } from "./types";
import type { DOMElement } from "@wangeditor/core/dist/core/src/utils/dom";

function parseHtml(elem: DOMElement): SlateElement {
  // elem HTML 结构 <span data-w-e-type="variable" data-w-e-is-void data-w-e-is-inline data-value="张三" data-info="xxx">@张三</span>

  const value = elem.getAttribute("data-value") || "";
  const label = elem.getAttribute("data-label") || "";
  return {
    type: "variable",
    value,
    label: label || elem.innerHTML,
    children: [{ text: "" }] // void node 必须有一个空白 text
  } as VariableElement;
}

const parseHtmlConf = {
  selector: "span[data-w-e-type='variable']",
  parseElemHtml: parseHtml
};

export default parseHtmlConf;
